"use strict";

import angular from "angular";
import _ from "lodash";

const name = "filterByName";
const factory = function filterByNameFilter() {
    return (list, search) => {
        if (!list) return [];
        const _searchText = _.deburr(search).toUpperCase();
        return list.filter((element) =>
            _.deburr(element.name).toUpperCase().includes(_searchText)
        );
    };
};
angular.module("nucont.shared").filter(name, factory);
export default { name, factory };
